module.exports = __webpack_public_path__ + "img/square.e3aa28b6.svg";